const initialState = { 
    created: "",
    email: "",
    enabled: true,
    first_name: "",
    last_name: "",
    provider: "",
    provider_uuid: "",
    roles: [],
    username: "",
    uuid: "",
    user_web_properties: {
        settings:{
            asideBg: false,
            asideColapsed: false,
            asideToggled: false,
            themeColor: 'darkBlue',        
            language: 'hr',
            customInvoiceFile: "" ,
            generickiPredlozakRacuna: true
        },

        columns: {
            provider:{
                main:{
                    full_name: false,
                    email: false,
                    phone_number: false,
                    address: false,
                    countries: false,
                    deleted: false,
                    created: false
                },
                user:{
                    email: false,
                    oib: false,
                    created: false,
                    enabled: false,
                    username: false,
                    last_name: true,
                    first_name: false,
                    user_non_expired: false,
                    account_non_locked: false,
                    account_non_expired: false
                },
                tax_rate: {
                    country: false,
                    tax_rate_mark: false,
                    tax_rate: false,
                    tax_rate_description: false,
                    note: false
                }
            },

            client:{
                main: {
                    company_name: false,
                    company_legal_ID: false,
                    company_address: false,
                    company_VAT_ID: false,
                    company_place: false,
                    company_postal_code: false,
                    email: false,
                    phone_number: false,
                    login_domain: false,
                    in_VAT: false
                },
                business_premises: {
                    country: false,
                    deleted: false,
                    company_name: false,
                    business_premises_logo: false,
                    business_premises_mark: false,
                    business_premises_name: false,
                    business_premises_place: false,
                    business_premises_remark: false,
                    business_premises_address: false,
                    business_premises_postal_code: false
                },
                terminal: {
                    description: false,
                    business_premises: false,
                    tid: false,
                    created: false,
                    otp_valid_until: false,
                    roles: false,
                    enabled: false,
                    account_non_expired: false,
                    account_non_locked: false,
                    user_non_expired: false,
                    otp_is_valid: false
                },
                operator: {
                    client: false,
                    operator_username: false,
                    operator_mark: false,
                    operator_name: false,
                    operator_surname: false,
                    operator_ID: false
                },
                user: {
                    username: false,
                    email: false,
                    first_name: false,
                    last_name: false,
                    client: false,
                    deleted: false,
                    enabled: false,
                    account_non_expired: false,
                    account_non_locked: false
                }                
            },

            transaction: {
                main: {
                    id: false,
                    customer_name: false,
                    customer_id: false,
                    jir: false,
                    amount: false,
                    currency: false,
                    country: false,
                    country_code: false,
                    email: false,
                    item_code: false,
                    item_name: false,
                    item_quantity: false,
                    payment_type: false,
                    transaction_date: false,
                    transaction_type: false,
                    created: false
                }
            }
        }
        
    }   
};


const reducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {

    case "MAP_ALL_INFO":
        return {
            ...state,
            created: action.data.created,
            email: action.data.email,
            enabled: action.data.enabled,
            first_name: action.data.first_name,
            last_name: action.data.last_name,
            provider: action.data.provider,
            provider_uuid: action.data.provider_uuid,
            roles: action.data.roles,
            username: action.data.username,
            uuid: action.data.uuid,
            user_web_properties: action.data.user_web_properties
        }

    case "USER_MAP_SETTINGS":       
        return {
            ...state,
            user_web_properties:{
                ...state.user_web_properties,
                settings:{
                    ...state.user_web_properties.settings,
                    [action.data.column]: action.data.value
                }
            }
        }

    case "USER_MAP_COLUMNS":
        return {
            ...state,
            user_web_properties:{
                ...state.user_web_properties,
                columns:{
                    ...state.user_web_properties.columns,
                    [action.data.menu]: {
                        ...state.user_web_properties.columns[action.data.menu],
                        [action.data.view]: {
                            ...state.user_web_properties.columns[action.data.menu][action.data.view],
                            [action.data.column]: !state.user_web_properties.columns[action.data.menu][action.data.view][action.data.column]
                        }
                    }
                }
            }
        }

    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
